import React, { FC, memo } from 'react';
import { FormDescriptionStyled } from './styles';

interface Props {
  children?: React.ReactNode;
  title: string;
}

const FormDescription: FC<Props> = ({ children, title }) => (
  <FormDescriptionStyled>
    <h3>{title}</h3>
    {children}
  </FormDescriptionStyled>
);

export default memo(FormDescription);
